import {
    DeferredFixedPaymentRow,
    DeferredVariablePaymentRow,
    JvEquityRow,
    CorporateEquityRow,
    DEFERRED_FIXED_PAYMENT_COLUMN_LABELS,
    DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS,
    JV_EQUITY_COLUMN_LABELS,
    CORPORATE_EQUITY_COMMON_COLUMN_LABELS,
    CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS,
    DeferredVariablePaymentType,
    DeferredFixedPaymentType,
    DfpCompoundingFrequency,
    PutCallRight,
    PaymentTiming,
    DividendPaymentTiming,
    DIVIDEND_PAYMENT_TIMING_LABELS,
    CompoundingFrequency,
    COMPOUNDING_FREQUENCY_LABELS,
    YES_VALUE,
    NO_VALUE,
} from '../../../../../../slices/marketplace/loi-form/term-form';
import { DetailColumnDef, DetailRow } from './TermsFormDetailBlock';

export const DFP_COLUMN_DEFS: DetailColumnDef[] = [
    { key: DEFERRED_FIXED_PAYMENT_COLUMN_LABELS.paymentTiming, type: 'select', selectOptions: Object.values(PaymentTiming), thStyle: { width: '150px', minWidth: '150px' } },
    { key: DEFERRED_FIXED_PAYMENT_COLUMN_LABELS.type, type: 'select', selectOptions: [DeferredFixedPaymentType.PrincipalOnly, DeferredFixedPaymentType.PrincipalPlusAccruedInterest], thStyle: { width: '240px', minWidth: '240px' } },
    { key: DEFERRED_FIXED_PAYMENT_COLUMN_LABELS.amount, type: 'currency' },
    { key: DEFERRED_FIXED_PAYMENT_COLUMN_LABELS.annualizedInterestAccrualRate, type: 'percent', headerTooltip: 'For example, 12% compounded monthly is an annualized interest rate of 12.68%', thStyle: { width: '110px', minWidth: '110px' } },
    { key: DEFERRED_FIXED_PAYMENT_COLUMN_LABELS.compoundingFrequency, type: 'select', selectOptions: Object.values(DfpCompoundingFrequency), thStyle: { width: '150px', minWidth: '150px' } },
    { key: DEFERRED_FIXED_PAYMENT_COLUMN_LABELS.contingent, type: 'yesno' },
    { key: DEFERRED_FIXED_PAYMENT_COLUMN_LABELS.contingencyDependentVariable, thStyle: { width: '165px', minWidth: '165px' } },
    { key: DEFERRED_FIXED_PAYMENT_COLUMN_LABELS.contDvMinimumValue, type: 'currency' },
    { key: DEFERRED_FIXED_PAYMENT_COLUMN_LABELS.employmentContingency, type: 'yesno' },
    { key: DEFERRED_FIXED_PAYMENT_COLUMN_LABELS.tailPeriodForEmployment },
    { key: DEFERRED_FIXED_PAYMENT_COLUMN_LABELS.buyerCalculationPeriod, type: 'days', thStyle: { width: '150px', minWidth: '150px' } },
    { key: DEFERRED_FIXED_PAYMENT_COLUMN_LABELS.sellerCalculationResponsePeriod, type: 'days', thStyle: { width: '150px', minWidth: '150px' } },
    { key: DEFERRED_FIXED_PAYMENT_COLUMN_LABELS.paymentDate, type: 'days', thStyle: { width: '150px', minWidth: '150px' } },
];

export const DVP_COLUMN_DEFS: DetailColumnDef[] = [
    { key: DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.paymentTiming, type: 'select', selectOptions: Object.values(PaymentTiming), thStyle: { width: '150px', minWidth: '150px' } },
    { key: DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.ownershipPercentage, type: 'percent' },
    { key: DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.type, type: 'select', selectOptions: [DeferredVariablePaymentType.Earnout, DeferredVariablePaymentType.Synthetic], thStyle: { width: '105px', minWidth: '105px' } },
    { key: DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.sellerPostCloseOwnershipStake, type: 'percent' },
    { key: DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.valueAtClosing, type: 'currency' },
    { key: DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.calculationDependentVariable, thStyle: { width: '165px', minWidth: '165px' } },
    { key: DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.calcDvBaselineValue, type: 'currency' },
    { key: DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.calculationMultiple },
    { key: DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.maximumPayment, type: 'currency' },
    { key: DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.employmentContingency, type: 'yesno' },
    { key: DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.tailPeriodForEmploymentContingency },
    { key: DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.penaltyMultiple },
    { key: DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.distributionPeriodicity },
    { key: DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.putCallRight, type: 'select', selectOptions: Object.values(PutCallRight), thStyle: { width: '150px', minWidth: '150px' } },
    { key: DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.putCallExplanation, type: 'textarea', thStyle: { width: '220px', minWidth: '220px' } },
    { key: DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.buyerCalculationPeriod, type: 'days', thStyle: { width: '150px', minWidth: '150px' } },
    { key: DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.sellerCalculationResponsePeriod, type: 'days', thStyle: { width: '150px', minWidth: '150px' } },
    { key: DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.paymentDate, type: 'days', thStyle: { width: '150px', minWidth: '150px' } },
];

export const JV_COLUMN_DEFS: DetailColumnDef[] = [
    { key: JV_EQUITY_COLUMN_LABELS.valueAtClosing, type: 'currency' },
    { key: JV_EQUITY_COLUMN_LABELS.paymentTiming, type: 'select', selectOptions: Object.values(PaymentTiming), thStyle: { width: '150px', minWidth: '150px' } },
    { key: JV_EQUITY_COLUMN_LABELS.sellerOwnershipPercentage, type: 'percent' },
    { key: JV_EQUITY_COLUMN_LABELS.calculationDependentVariable, thStyle: { width: '165px', minWidth: '165px' } },
    { key: JV_EQUITY_COLUMN_LABELS.calcDvBaselineValue, type: 'currency' },
    { key: JV_EQUITY_COLUMN_LABELS.calculationMultiple },
    { key: JV_EQUITY_COLUMN_LABELS.employmentContingency, type: 'yesno' },
    { key: JV_EQUITY_COLUMN_LABELS.tailPeriodForEmploymentContingency },
    { key: JV_EQUITY_COLUMN_LABELS.penaltyMultiple },
    { key: JV_EQUITY_COLUMN_LABELS.distributionPeriodicity },
    { key: JV_EQUITY_COLUMN_LABELS.putCallRight, type: 'select', selectOptions: Object.values(PutCallRight), thStyle: { width: '150px', minWidth: '150px' } },
    { key: JV_EQUITY_COLUMN_LABELS.putCallExplanation, type: 'textarea', thStyle: { width: '220px', minWidth: '220px' } },
    { key: JV_EQUITY_COLUMN_LABELS.buyerCalculationPeriod, type: 'days', thStyle: { width: '150px', minWidth: '150px' } },
    { key: JV_EQUITY_COLUMN_LABELS.sellerCalculationResponsePeriod, type: 'days', thStyle: { width: '150px', minWidth: '150px' } },
    { key: JV_EQUITY_COLUMN_LABELS.paymentDate, type: 'days', thStyle: { width: '150px', minWidth: '150px' } },
];

export const CORP_COMMON_COLUMN_DEFS: DetailColumnDef[] = [
    { key: CORPORATE_EQUITY_COMMON_COLUMN_LABELS.valueAtClosing, type: 'currency' },
    { key: CORPORATE_EQUITY_COMMON_COLUMN_LABELS.expectedTimingToRecap },
    { key: CORPORATE_EQUITY_COMMON_COLUMN_LABELS.expectedPayoutAsMultipleOfCurrentValue },
    { key: CORPORATE_EQUITY_COMMON_COLUMN_LABELS.contingent, type: 'yesno' },
    { key: CORPORATE_EQUITY_COMMON_COLUMN_LABELS.contingencyDependentVariable, thStyle: { width: '165px', minWidth: '165px' } },
    { key: CORPORATE_EQUITY_COMMON_COLUMN_LABELS.contDvMinimumValue, type: 'currency' },
    { key: CORPORATE_EQUITY_COMMON_COLUMN_LABELS.employmentContingency, type: 'yesno' },
    { key: CORPORATE_EQUITY_COMMON_COLUMN_LABELS.tailPeriodForEmploymentContingency },
    { key: CORPORATE_EQUITY_COMMON_COLUMN_LABELS.putCallRight, type: 'select', selectOptions: Object.values(PutCallRight), thStyle: { width: '150px', minWidth: '150px' } },
    { key: CORPORATE_EQUITY_COMMON_COLUMN_LABELS.putCallExplanation, type: 'textarea', thStyle: { width: '220px', minWidth: '220px' } },
    { key: CORPORATE_EQUITY_COMMON_COLUMN_LABELS.buyerCalculationPeriod, type: 'days', thStyle: { width: '150px', minWidth: '150px' } },
    { key: CORPORATE_EQUITY_COMMON_COLUMN_LABELS.sellerCalculationResponsePeriod, type: 'days', thStyle: { width: '150px', minWidth: '150px' } },
];

export const CORP_PREFERRED_COLUMN_DEFS: DetailColumnDef[] = [
    { key: CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.valueAtClosing, type: 'currency' },
    { key: CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.annualDividendRate, type: 'percent' },
    { key: CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.dividendPaymentTiming, type: 'select', selectOptions: Object.values(DividendPaymentTiming), selectOptionLabels: DIVIDEND_PAYMENT_TIMING_LABELS, thStyle: { width: '150px', minWidth: '150px' } },
    { key: CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.compoundingFrequency, type: 'select', selectOptions: Object.values(CompoundingFrequency), selectOptionLabels: COMPOUNDING_FREQUENCY_LABELS, thStyle: { width: '150px', minWidth: '150px' } },
    { key: CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.expectedTimingToRecap },
    { key: CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.convertibleIntoCommon, type: 'yesno' },
    { key: CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.conversionRatio },
    { key: CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.contingent, type: 'yesno' },
    { key: CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.contingencyDependentVariable, thStyle: { width: '165px', minWidth: '165px' } },
    { key: CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.contDvMinimumValue, type: 'currency' },
    { key: CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.employmentContingency, type: 'yesno' },
    { key: CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.tailPeriodForEmploymentContingency },
    { key: CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.putCallRight, type: 'select', selectOptions: Object.values(PutCallRight), thStyle: { width: '150px', minWidth: '150px' } },
    { key: CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.putCallExplanation, type: 'textarea', thStyle: { width: '220px', minWidth: '220px' } },
    { key: CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.buyerCalculationPeriod, type: 'days', thStyle: { width: '150px', minWidth: '150px' } },
    { key: CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.sellerCalculationResponsePeriod, type: 'days', thStyle: { width: '150px', minWidth: '150px' } },
];

export function dfpRowToKeyValue(row: DeferredFixedPaymentRow): DetailRow {
    return {
        [DEFERRED_FIXED_PAYMENT_COLUMN_LABELS.paymentTiming]: row.paymentTiming ?? null,
        [DEFERRED_FIXED_PAYMENT_COLUMN_LABELS.type]: row.type ?? null,
        [DEFERRED_FIXED_PAYMENT_COLUMN_LABELS.amount]:
            row.amount != null ? String(row.amount) : null,
        [DEFERRED_FIXED_PAYMENT_COLUMN_LABELS.annualizedInterestAccrualRate]:
            row.annualizedInterestAccrualRate ?? null,
        [DEFERRED_FIXED_PAYMENT_COLUMN_LABELS.compoundingFrequency]:
            row.compoundingFrequency ?? null,
        [DEFERRED_FIXED_PAYMENT_COLUMN_LABELS.contingent]: row.contingent ?? null,
        [DEFERRED_FIXED_PAYMENT_COLUMN_LABELS.contingencyDependentVariable]:
            row.contingencyDependentVariableValue ?? null,
        [DEFERRED_FIXED_PAYMENT_COLUMN_LABELS.contDvMinimumValue]:
            row.contDvMinimumValue != null ? String(row.contDvMinimumValue) : null,
        [DEFERRED_FIXED_PAYMENT_COLUMN_LABELS.employmentContingency]:
            row.employmentContingency ?? null,
        [DEFERRED_FIXED_PAYMENT_COLUMN_LABELS.tailPeriodForEmployment]:
            row.tailPeriodForEmployment ?? null,
        [DEFERRED_FIXED_PAYMENT_COLUMN_LABELS.buyerCalculationPeriod]:
            row.buyerCalculationPeriodDays != null ? String(row.buyerCalculationPeriodDays) : null,
        [DEFERRED_FIXED_PAYMENT_COLUMN_LABELS.sellerCalculationResponsePeriod]:
            row.sellerCalculationResponsePeriodDays != null ? String(row.sellerCalculationResponsePeriodDays) : null,
        [DEFERRED_FIXED_PAYMENT_COLUMN_LABELS.paymentDate]:
            row.paymentDateDays != null ? String(row.paymentDateDays) : null,
    };
}

export function dvpRowToKeyValue(row: DeferredVariablePaymentRow): DetailRow {
    return {
        [DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.paymentTiming]: row.paymentTiming ?? null,
        [DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.type]:
            row.type != null ? String(row.type) : null,
        [DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.valueAtClosing]:
            row.valueAtClosing != null ? String(row.valueAtClosing) : null,
        [DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.ownershipPercentage]:
            row.ownershipPercentage ?? null,
        [DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.sellerPostCloseOwnershipStake]:
            row.sellerPostCloseOwnershipStake ?? null,
        [DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.calculationDependentVariable]:
            row.calculationDependentVariable ?? null,
        [DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.calcDvBaselineValue]:
            row.calcDvBaselineValue != null ? String(row.calcDvBaselineValue) : null,
        [DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.calculationMultiple]:
            row.calculationMultiple ?? null,
        [DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.maximumPayment]:
            row.maximumPayment ?? null,
        [DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.employmentContingency]:
            row.employmentContingency ?? null,
        [DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.tailPeriodForEmploymentContingency]:
            row.tailPeriodForEmploymentContingency ?? null,
        [DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.penaltyMultiple]:
            row.penaltyMultiple ?? null,
        [DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.distributionPeriodicity]:
            row.distributionPeriodicity ?? null,
        [DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.buyerCalculationPeriod]:
            row.buyerCalculationPeriodDays != null ? String(row.buyerCalculationPeriodDays) : null,
        [DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.sellerCalculationResponsePeriod]:
            row.sellerCalculationResponsePeriodDays != null ? String(row.sellerCalculationResponsePeriodDays) : null,
        [DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.paymentDate]:
            row.paymentDateDays != null ? String(row.paymentDateDays) : null,
        [DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.putCallRight]: row.putCallRight ?? null,
        [DEFERRED_VARIABLE_PAYMENT_COLUMN_LABELS.putCallExplanation]: row.putCallExplanation ?? null,
    };
}

export function jvRowToKeyValue(row: JvEquityRow | null | undefined): DetailRow {
    return {
        [JV_EQUITY_COLUMN_LABELS.valueAtClosing]:
            row?.valueAtClosing != null ? String(row.valueAtClosing) : null,
        [JV_EQUITY_COLUMN_LABELS.sellerOwnershipPercentage]: row?.sellerOwnershipPercentage ?? null,
        [JV_EQUITY_COLUMN_LABELS.paymentTiming]: row?.paymentTiming ?? null,
        [JV_EQUITY_COLUMN_LABELS.calculationDependentVariable]:
            row?.calculationDependentVariable ?? null,
        [JV_EQUITY_COLUMN_LABELS.calcDvBaselineValue]:
            row?.calcDvBaselineValue != null ? String(row.calcDvBaselineValue) : null,
        [JV_EQUITY_COLUMN_LABELS.calculationMultiple]: row?.calculationMultiple ?? null,
        [JV_EQUITY_COLUMN_LABELS.employmentContingency]: row?.employmentContingency ?? null,
        [JV_EQUITY_COLUMN_LABELS.tailPeriodForEmploymentContingency]:
            row?.tailPeriodForEmploymentContingency ?? null,
        [JV_EQUITY_COLUMN_LABELS.penaltyMultiple]: row?.penaltyMultiple ?? null,
        [JV_EQUITY_COLUMN_LABELS.distributionPeriodicity]: row?.distributionPeriodicity ?? null,
        [JV_EQUITY_COLUMN_LABELS.buyerCalculationPeriod]:
            row?.buyerCalculationPeriodDays != null ? String(row.buyerCalculationPeriodDays) : null,
        [JV_EQUITY_COLUMN_LABELS.sellerCalculationResponsePeriod]:
            row?.sellerCalculationResponsePeriodDays != null ? String(row.sellerCalculationResponsePeriodDays) : null,
        [JV_EQUITY_COLUMN_LABELS.paymentDate]:
            row?.paymentDateDays != null ? String(row.paymentDateDays) : null,
        [JV_EQUITY_COLUMN_LABELS.putCallRight]: row?.putCallRight ?? null,
        [JV_EQUITY_COLUMN_LABELS.putCallExplanation]: row?.putCallExplanation ?? null,
    };
}

export function corpCommonRowToKeyValue(row: CorporateEquityRow | null | undefined): DetailRow {
    return {
        [CORPORATE_EQUITY_COMMON_COLUMN_LABELS.valueAtClosing]:
            row?.valueAtClosing != null ? String(row.valueAtClosing) : null,
        [CORPORATE_EQUITY_COMMON_COLUMN_LABELS.expectedTimingToRecap]:
            row?.expectedTimingToRecap ?? null,
        [CORPORATE_EQUITY_COMMON_COLUMN_LABELS.expectedPayoutAsMultipleOfCurrentValue]:
            row?.expectedPayoutAsMultipleOfCurrentValue ?? null,
        [CORPORATE_EQUITY_COMMON_COLUMN_LABELS.contingent]: row?.contingent ?? null,
        [CORPORATE_EQUITY_COMMON_COLUMN_LABELS.contingencyDependentVariable]:
            row?.contingencyDependentVariableValue ?? null,
        [CORPORATE_EQUITY_COMMON_COLUMN_LABELS.contDvMinimumValue]:
            row?.contDvMinimumValue != null ? String(row.contDvMinimumValue) : null,
        [CORPORATE_EQUITY_COMMON_COLUMN_LABELS.employmentContingency]:
            row?.employmentContingency === YES_VALUE ? YES_VALUE : NO_VALUE,
        [CORPORATE_EQUITY_COMMON_COLUMN_LABELS.tailPeriodForEmploymentContingency]:
            row?.tailPeriodForEmploymentContingency ?? null,
        [CORPORATE_EQUITY_COMMON_COLUMN_LABELS.penaltyMultiple]:
            row?.penaltyMultiple ?? null,
        [CORPORATE_EQUITY_COMMON_COLUMN_LABELS.buyerCalculationPeriod]:
            row?.buyerCalculationPeriodDays != null ? String(row.buyerCalculationPeriodDays) : null,
        [CORPORATE_EQUITY_COMMON_COLUMN_LABELS.sellerCalculationResponsePeriod]:
            row?.sellerCalculationResponsePeriodDays != null ? String(row.sellerCalculationResponsePeriodDays) : null,
        [CORPORATE_EQUITY_COMMON_COLUMN_LABELS.paymentDate]:
            row?.paymentDateDays != null ? String(row.paymentDateDays) : null,
        [CORPORATE_EQUITY_COMMON_COLUMN_LABELS.putCallRight]: row?.putCallRight ?? null,
        [CORPORATE_EQUITY_COMMON_COLUMN_LABELS.putCallExplanation]: row?.putCallExplanation ?? null,
    };
}

export function corpPreferredRowToKeyValue(row: CorporateEquityRow | null | undefined): DetailRow {
    return {
        [CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.valueAtClosing]:
            row?.valueAtClosing != null ? String(row.valueAtClosing) : null,
        [CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.annualDividendRate]:
            row?.annualDividendRate ?? null,
        [CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.dividendPaymentTiming]:
            row?.dividendPaymentTiming ?? null,
        [CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.compoundingFrequency]:
            row?.compoundingFrequency ?? null,
        [CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.expectedTimingToRecap]:
            row?.expectedTimingToRecap ?? null,
        [CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.convertibleIntoCommon]:
            row?.convertibleIntoCommon === true ? YES_VALUE : NO_VALUE,
        [CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.conversionRatio]:
            row?.conversionRatio != null ? String(row.conversionRatio) : null,
        [CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.contingent]: row?.contingent ?? null,
        [CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.contingencyDependentVariable]:
            row?.contingencyDependentVariableValue ?? null,
        [CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.contDvMinimumValue]:
            row?.contDvMinimumValue != null ? String(row.contDvMinimumValue) : null,
        [CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.employmentContingency]:
            row?.employmentContingency === YES_VALUE ? YES_VALUE : NO_VALUE,
        [CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.tailPeriodForEmploymentContingency]:
            row?.tailPeriodForEmploymentContingency ?? null,
        [CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.penaltyMultiple]:
            row?.penaltyMultiple ?? null,
        [CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.buyerCalculationPeriod]:
            row?.buyerCalculationPeriodDays != null ? String(row.buyerCalculationPeriodDays) : null,
        [CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.sellerCalculationResponsePeriod]:
            row?.sellerCalculationResponsePeriodDays != null ? String(row.sellerCalculationResponsePeriodDays) : null,
        [CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.paymentDate]:
            row?.paymentDateDays != null ? String(row.paymentDateDays) : null,
        [CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.putCallRight]: row?.putCallRight ?? null,
        [CORPORATE_EQUITY_PREFERRED_COLUMN_LABELS.putCallExplanation]: row?.putCallExplanation ?? null,
    };
}

export function totalDfp(rows: DeferredFixedPaymentRow[]): number {
    return rows.reduce((s, r) => s + (Number(r.amount) || 0), 0);
}

export function totalDvp(rows: DeferredVariablePaymentRow[]): number {
    return rows.reduce((s, r) => s + (Number(r.valueAtClosing) || 0), 0);
}
